<div class="register">
    <div class="body">
        <div class="flex flex-col gap-16">
            <div class="inp">
                <fun-input placeholder="Nombre"
                    [parentForm]="partnerForm"
                    [formControlKeys]="formControlKeys"
                    [errorMessages]="errorMessages"
                    [isSubmit]="isSubmit"
                    controlName="name"
                    type="text"
                    [errorLogin]="errorAmount"
                    labelName="Nombre"
                    (selectChange)="getInfo()"
                    (keyup)="getInfo()"
                    (click)="getInfo()"></fun-input>
            </div>
            <div class="inp">
                <fun-input placeholder="Apellidos"
                    [parentForm]="partnerForm"
                    [formControlKeys]="formControlKeys"
                    [errorMessages]="errorMessages"
                    [isSubmit]="isSubmit"
                    controlName="surname"
                    type="text"
                    [errorLogin]="errorAmount"
                    labelName="Apellidos"
                    (selectChange)="getInfo()"
                    (keyup)="getInfo()"
                    (click)="getInfo()"></fun-input>
            </div>
            <!-- <div class="inp">
                <fun-input placeholder="Ejemplo: 33,33"
                    [parentForm]="partnerForm"
                    [formControlKeys]="formControlKeys"
                    [errorMessages]="errorMessages"
                    [isSubmit]="isSubmit"
                    controlName="ownershipPercentaje"
                    type="number"
                    [errorLogin]="errorAmount"
                    labelName="Porcentaje de la sociedad (cantidad sobre 100)"
                    (selectChange)="getInfo()"
                    (keyup)="getInfo()"
                    (click)="getInfo()"></fun-input>
            </div> -->
            <div class="inp">
                <p class="font-sans text-eggplant-80 text-l text-center">Fecha de nacimiento</p>
                <fun-input placeholder="Fecha de nacimiento"
                    [parentForm]="partnerForm"
                    [formControlKeys]="formControlKeys"
                    [errorMessages]="errorMessages"
                    [isSubmit]="isSubmit"
                    controlName="birthDate"
                    type="date"
                    [errorLogin]="errorAmount"
                    labelName="Fecha de nacimiento"
                    (selectChange)="getInfo()"
                    (keyup)="getInfo()"
                    (click)="getInfo()"></fun-input>
            </div>
        </div>
    </div>
</div>